import { Diplomas, StaffLevelRights } from '@/types/Staff'
import { RightsRW } from '@/types/StaffRights'

export function convertDegreeToString(degree: Diplomas, t: (key: string) => string): string {
    switch (degree) {
        case Diplomas.bafa:
            return t('bafa')
        case Diplomas.aepe:
            return t('aepe')
        case Diplomas.deap:
            return t('deap')
        case Diplomas.deeje:
            return t('deeje')
        case Diplomas.atsem:
            return t('atsem')
        case Diplomas.dep:
            return t('dep')
        case Diplomas.dei:
            return t('dei')
        case Diplomas.no:
            return t('withoutDiploma')
        case Diplomas.other:
            return t('other')
    }
}

export function returnRoleName(t: (key: string) => string, staffRights?: StaffLevelRights): string {
    if (!staffRights) return t('noAccess')

    const rights: RightsRW[] = [
        staffRights.rw_staffs,
        staffRights.rw_closing_days,
        staffRights.rw_event_days,
        staffRights.rw_families,
        staffRights.rw_news,
        staffRights.rw_suggestions,
        staffRights.rw_occasional_slot,
        staffRights.rw_child,
        staffRights.rw_params_daycare,
        staffRights.rw_regular_slot,
        staffRights.rw_request_slot,
        staffRights.rw_staff_work,
        staffRights.rw_task_note,
        staffRights.rw_meal
    ]

    if (rights.every((right: RightsRW): boolean => right === 2)) {
        return t('allAccess')
    } else if (rights.every((right: RightsRW): boolean => right === 0)) {
        return t('noAccess')
    } else {
        return t('personalizedRole')
    }
}
